import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import electronicDeviceRoute from "../apps/electronic-equipment/routes";
import urbanMobilityRoute from "../apps/urban-mobility/routes";
import calculatorWithdraw from "../apps/calculator-withdraw/routes";
import healthfamilyPlanRoute from "../apps/health-max/routes";
import familyCombinedPremiumRoute from "../apps/familycombined/routes";
import workOcassionRoute from "../apps/personal-accident/work-occasion/routes";
import integralMaxRoute from "../apps/personal-accident/integro-max/routes";
import AP24HsRoute from "../apps/personal-accident/ap-24-hs/routes";
import travelAssistanceRoute from "../apps/travel-assistance/routes";
import caucionAlquilerRoute from "../apps/caucion-alquiler/routes";
import homeRoute from '../apps/home/routes';


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    ...urbanMobilityRoute,
    ...healthfamilyPlanRoute,
    ...electronicDeviceRoute,
    ...familyCombinedPremiumRoute,
    ...workOcassionRoute,
    ...integralMaxRoute,
    ...AP24HsRoute,
    ...calculatorWithdraw,
    ...travelAssistanceRoute,
    ...caucionAlquilerRoute,
    ...homeRoute // Ruta comod�n debe ir al final siempre
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.afterEach((to) => {
    const pageTitle = to.meta.pageTitle || 'Sancor Seguros'; 
    document.title = pageTitle;
    // Configura los meta tags de la p�gina
    if (to.meta.metaTags) {
        to.meta.metaTags.forEach(tag => {
            const elements = document.getElementsByTagName('meta');
            let element = Array.from(elements).find(el => el.getAttribute('name') === tag.name);
            if (element) {
                element.setAttribute('content', tag.content);
            } else {
                element = document.createElement('meta');
                element.setAttribute('name', tag.name);
                element.setAttribute('content', tag.content);
                document.head.appendChild(element);
            }
        });
    }
});

export default router;
